import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Input, Button, message } from 'antd';
import {estatus_baja} from '../../../../constants/bajaEmpleado';
const { TextArea } = Input;

const ModalCambiarEstatus = ({ visible, onClose, currentStatus, empleadoData, onStatusChange }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const statusOptions = estatus_baja.list;

    useEffect(() => {
        if (visible && currentStatus !== undefined) {
            form.setFieldsValue({
                estatus: currentStatus,
                comentario: ''
            });
        }
    }, [visible, currentStatus, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            handleClose();
        } catch (error) {
            if (error.errorFields) {
                message.error('Por favor, complete todos los campos requeridos');
            } else {
                message.error('Error al cambiar el estatus');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        form.resetFields();
        onClose();
    };

    const getStatusLabel = (value) => {
        const status = statusOptions.find(option => option.value === value);
        return status ? status.label : 'Desconocido';
    };

    return (
        <Modal
            title="Cambiar Estatus de Finiquito"
            open={visible}
            onCancel={handleClose}
            width={500}
            footer={[
                <Button key="cancel" onClick={handleClose} disabled={loading}>
                    Salir
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    onClick={handleSubmit}
                    loading={loading}
                >
                    Guardar
                </Button>
            ]}
            style={{ top: 50 }}
            maskClosable={false}
        >
            <Form
                form={form}
                layout="vertical"
                size="middle"
            >
                <Form.Item
                    label="Estatus"
                    name="estatus"
                    rules={[
                        { required: true, message: 'Por favor seleccione un estatus' }
                    ]}
                >
                    <Select
                        placeholder="Seleccione un estatus"
                        options={statusOptions}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item
                    label="Comentario"
                    name="comentario"
                    rules={[
                        { required: true, message: 'Por favor ingrese un comentario' }
                    ]}
                >
                    <TextArea
                        placeholder="Ingrese un comentario sobre el cambio de estatus"
                        rows={4}
                        showCount
                        maxLength={500}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalCambiarEstatus;